import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import classnames from 'classnames'
import { browserHistory } from 'react-router'
import Moment from 'moment'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import {
  updateProfile,
  UPDATE_PROFILE,
  updatePassword,
  UPDATE_PASSWORD,
  deleteAccount,
  getProfileInfo,
  toggleUpdate,
  unsubscribe,
} from '_modules/user/actions'
import { planTypeForValue, planTypes } from '_utils/planType'
import { createFieldMissingErrorMessage, deepCopyJSON } from '_utils/helperFunction'

import styles from './styles.css'

const successToastOptions = {
  type: 'success',
  autoClose: 3000,
  hideProgressBar: true,
}

const errorToastOptions = {
  type: 'error',
  autoClose: 3000,
  hideProgressBar: true,
}

const mapStateToProps = ({ user, loading, error }) => ({
  user,
  isLoadingPasswordChange: !!loading.get(UPDATE_PASSWORD.ACTION),
  passwordChangeError: error.get(UPDATE_PASSWORD.ACTION),
  isLoadingProfileChange: !!loading.get(UPDATE_PROFILE.ACTION),
  profileChangeError: error.get(UPDATE_PROFILE.ACTION),
})

const mapDispatchToProps = {
  updateProfile,
  updatePassword,
  deleteAccount,
  getProfileInfo,
  toggleUpdate,
  unsubscribe,
}

class Profile extends PureComponent {
  static propTypes = {
    user: ImmutableProptypes.map.isRequired,
    updateProfile: PropTypes.func.isRequired,
    updatePassword: PropTypes.func.isRequired,
    deleteAccount: PropTypes.func.isRequired,
    getProfileInfo: PropTypes.func.isRequired,
    toggleUpdate: PropTypes.func.isRequired,
    isLoadingPasswordChange: PropTypes.bool.isRequired,
    passwordChangeError: PropTypes.string.isRequired,
    isLoadingProfileChange: PropTypes.bool.isRequired,
    profileChangeError: PropTypes.string.isRequired,
    unsubscribe: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
    passwordChangeError: '',
    profileChangeError: '',
  }

  state = {
    email: '',
    firstName: '',
    lastName: '',
    oldPassword: '',
    newPassword: '',
    createdAt: undefined,
    updatedAt: undefined,
    updates: false,
    planType: 100,
  }

  componentWillMount() {
    this.props.getProfileInfo()
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    const {
      isLoadingPasswordChange,
      passwordChangeError,
      isLoadingProfileChange,
      profileChangeError,
    } = nextProps
    if (this.props.isLoadingPasswordChange && !isLoadingPasswordChange) {
      if (!passwordChangeError) {
        toast.success('Password Updated', successToastOptions)
      } else {
        this.props.displayError(passwordChangeError)
      }
    }
    if (this.props.isLoadingProfileChange && !isLoadingProfileChange) {
      if (!profileChangeError) {
        toast.success('Profile Updated', successToastOptions)
      } else {
        this.props.displayError(profileChangeError)
      }
    }
    this.getState(nextProps)
  }

  onChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  onChangeTrim = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value.trim(),
    })
  }

  onCheckboxChange = event => {
    const { name } = event.target

    this.setState({
      [name]: !this.state[name],
    })
    this.props.toggleUpdate()
  }

  onUpdateProfile = () => {
    const { firstName, lastName, email } = this.state

    if (!firstName || !lastName || !email) {
      this.props.displayError(createFieldMissingErrorMessage({ firstName, lastName, email }))
      return
    }

    const payload = {
      firstName,
      lastName,
      email,
    }
    this.props.updateProfile(payload)
  }

  onChangePassword = () => {
    const { email, oldPassword, newPassword } = this.state

    if (!email || !oldPassword || !newPassword) {
      this.props.displayError(createFieldMissingErrorMessage({ email, oldPassword, newPassword }))
      return
    }

    const payload = {
      email,
      password: oldPassword,
      password2: newPassword,
    }

    this.props.updatePassword(payload)
    this.setState({
      oldPassword: '',
      newPassword: '',
    })
  }

  onDeleteAccount = () => {
    this.props.deleteAccount()
    browserHistory.push('/login')
  }

  onUpgradePlan = () => {
    browserHistory.push('/subscribe')
  }

  onCancelPlan = () => {
    this.props.unsubscribe()
  }

  onBackClick = () => {
    browserHistory.goBack()
  }

  getState = props => {
    const user = props.user.toJS()
    const { email, firstName, lastName, createdAt, updatedAt, updates, planType } = user
    this.setState({ email, firstName, lastName, createdAt, updatedAt, updates, planType })
  }

  render() {
    const {
      email,
      firstName,
      lastName,
      oldPassword,
      newPassword,
      createdAt,
      updatedAt,
      updates,
      planType,
    } = this.state

    return (
      <div ref={div => (this.divRef = div)} className={classnames(styles.main, styles.Grid)}>
        <button
          style={{ position: 'absolute', right: 25, top: 20 }}
          className={classnames(styles.backButton)}
          type="submit"
          onClick={this.onBackClick}
        >
          <i className="fa fa-times" />
        </button>
        <div className={classnames(styles['Grid-cell'], styles.section)}>
          <div className={classnames(styles.sectionTitle)}>Profile Information</div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>Email</p>
            <input
              type="text"
              id="email"
              value={email}
              onChange={this.onChangeTrim}
              className={styles.input}
            />
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>First Name</p>
            <input
              type="text"
              id="firstName"
              value={firstName}
              onChange={this.onChangeTrim}
              className={styles.input}
            />
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>Last Name</p>
            <input
              type="text"
              id="lastName"
              value={lastName}
              onChange={this.onChangeTrim}
              className={styles.input}
            />
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <button type="submit" onClick={this.onUpdateProfile}>
              Update Profile
            </button>
          </div>
        </div>

        <div className={classnames(styles['Grid-cell'], styles.section)}>
          <div className={classnames(styles.sectionTitle)}>Change Password</div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>Old Password</p>
            <input
              type="password"
              id="oldPassword"
              value={oldPassword}
              onChange={this.onChange}
              className={styles.input}
            />
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>New Password</p>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={this.onChange}
              className={styles.input}
            />
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <button type="submit" onClick={this.onChangePassword}>
              Change Password
            </button>
          </div>
        </div>

        <div className={classnames(styles['Grid-cell'], styles.section)}>
          <div className={classnames(styles.sectionTitle)}>Account Information</div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>
              Created At {Moment(createdAt).format('dddd, MMMM Do YYYY, h:mm:ss a')}
            </p>
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>
              Last Updated {Moment(updatedAt).format('dddd, MMMM Do YYYY, h:mm:ss a')}
            </p>
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <input
              type="checkbox"
              name="updates"
              checked={updates}
              onChange={this.onCheckboxChange}
              className={classnames(styles['sub-item'])}
            />
            <p className={classnames(styles['sub-item'])}>Email Updates</p>
          </div>
        </div>

        <div className={classnames(styles['Grid-cell'], styles.section)}>
          <div className={classnames(styles.sectionTitle)}>Subscription Information</div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>
              Plan Type: {planTypeForValue(planType)}
            </p>
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'])}>
              Please contact us to make changes to your subscription.
            </p>
          </div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            {planType < planTypes.team && (
              <button type="submit" onClick={this.onUpgradePlan}>
                Upgrade Plan
              </button>
            )}
            {/* {planType >= planTypes.pro && (
              <button type="submit" onClick={this.onCancelPlan}>
                Cancel Plan
              </button>
            )} */}
          </div>
        </div>

        <div className={classnames(styles['Grid-cell'], styles.section)}>
          <div className={classnames(styles.sectionTitle)}>Account Changes</div>
          <div className={classnames(styles['Grid-cell'], styles.item)}>
            <p className={classnames(styles['sub-item'], styles.paragraph)}>
              For other changes in your account, please email training@people-onthego.net or call
              415.503.1649
            </p>
          </div>
          {/* <div className={classnames(styles['Grid-cell'], styles.item)}>
            <button type="submit" onClick={this.onDeleteAccount}>
              Delete Account
            </button>
          </div> */}
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile)



// WEBPACK FOOTER //
// ./src/views/profile/index.js